import { Typeahead } from "react-bootstrap-typeahead";
import { Card, Col, CardBody, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicTypeaheads } from "../../../../Constant";
import { BASIC_TYPEAHEAD, STATE_OF_USA } from "../../../../Data/FormWidgets";

const BasicTypeAhead = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={BasicTypeaheads} span={BASIC_TYPEAHEAD} />
        <CardBody>
          <div id="the-basics">
            <Form className="theme-form">
              <div>
                <Typeahead options={STATE_OF_USA} placeholder="States of USA" id="Basic TypeAhead" />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicTypeAhead;
